export const mapInternalStateToPayload = state => {
  const {
    category,
    description,
    department,
    interview_template,
    languages = [],
    modules: { gma, personality, interview } = {},
    name,
    profile: { categories = {}, outputVariables = {} } = {},
  } = state

  return {
    category,
    description,
    department,
    interview_template,
    languages,
    modules: {
      gma,
      interview,
      personality,
    },
    name,
    profile: {
      categories,
      outputVariables,
    },
  }
}
